import { evaluateRoutingRules } from 'api/targeting'
import store from 'config/store'
import { setMatchedConversationRoutingRules } from 'modules/conversations/actions'
import { evaluateRoutingTargetingConditions } from 'modules/targeting/evaluation'
import { getTargetingEvaluationContext } from 'modules/targeting/utils'
import { omit } from 'ramda'
import { RoutingEvaluationRequestPayload } from 'types/targeting'
import { warn } from 'utils'

export const reevaluateRoutingRules = async () => {
  const { embed = {} } = store.getState()
  const targetingEvaluationContext = getTargetingEvaluationContext()

  const payload: RoutingEvaluationRequestPayload = omit(['inboxId'], targetingEvaluationContext)

  try {
    const { data } = await evaluateRoutingRules(embed.id, payload)

    if (!data) {
      return
    }

    const matchedRoutingRules = await evaluateRoutingTargetingConditions(data.routingEvaluationResults)
    store.dispatch(setMatchedConversationRoutingRules(matchedRoutingRules))
  } catch(err) {
    warn(['Failed to re-evaluate routing rules', err])
  }
}
